import {
  Box,
  Stack,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import { DotIcon } from "@pharmupp/p3-front-commons"
import type { PropsWithChildren } from "react"

export const NewsListGridContainer = ({
  columnNbr = 4,
  children,
}: PropsWithChildren<{ columnNbr?: number }>) => {
  const theme = useTheme()
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("md"))
  const finalColumnsNbr = isSmallDevice ? columnNbr - 1 : columnNbr

  return (
    <Box
      display="grid"
      gridTemplateColumns={`repeat(${finalColumnsNbr}, 1fr)`}
      gap={2}
    >
      {children}
    </Box>
  )
}

export const NewsListSectionTitle = ({
  title,
  dotLight = false,
}: { title: string; dotLight?: boolean }) => {
  const {
    palette: { secondary, grey },
  } = useTheme()
  const dotColor = dotLight ? secondary.main : grey.extraLight
  return (
    <Stack direction="row" alignItems="center" spacing={1.5} mb={5}>
      <DotIcon color={dotColor} size={8} />
      <Typography
        variant="h1"
        component={Box}
        align="left"
        fontWeight="500"
        color="primary.dark1"
        fontSize="1.3rem"
      >
        {title}
      </Typography>
    </Stack>
  )
}

export const NewsListSection = styled(Box)(({ theme: { spacing } }) => ({
  width: "100%",
  paddingBlock: spacing(5),
  paddingInline: spacing(4),
}))

export const TypoNoNews = styled(Typography)(({ theme: { spacing, palette } }) => ({
  marginTop: spacing(2),
  align: "left",
  fontWeight: 500,
  color: palette.common.darkBlue,
  display: "block",
}))
TypoNoNews.defaultProps = { variant: "17px" }
